/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, {useRef, useEffect} from "react"

import PropTypes from "prop-types"
import AOS from 'aos'
import 'aos/dist/aos.css'

import Footer from "./footer"

import "normalize.css"
import "./../assets/css/layout.scss"


const useMountEffect = (fun) => useEffect(fun, [])


const useScroll = () => {
  const htmlElRef = useRef(null)
  const executeScroll = () => {
    if(document.location.hash !== ''){
      window.scrollTo(0, (document.body.scrollHeight / 2.5))
    }
  
  }

  return [executeScroll, htmlElRef]
}



const Layout = ({ children, classMenu }) => {
  if (typeof window !== "undefined") {
    AOS.init({
      duration : 2000,
      mirror: true,
    });
  }
  return (
    <>
     
      <main className={classMenu}>{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
